<!-- 下单数量 -->
<template>

    <el-popover
            placement="top-start"
            title="下单明细"
            width="400"
            trigger="hover">
        <el-table :data="order.ordersize_set">
            <el-table-column width="145" prop="size.shop_id" label="尺码"/>
            <el-table-column width="120" prop="color" label="颜色"/>
            <el-table-column width="110" prop="ordered_amount" label="下单量"/>
        </el-table>
        <el-tag slot="reference" size="mini" type="primary">{{ order.order_num }}</el-tag>
    </el-popover>

</template>

<script>
    export default {
        name: "OrderNumCol",
        props: {order: Object},
    }

</script>

<style scoped>

</style>